/**
 * 抽壳移除面拓扑绑定构建。
 *
 * 设计说明：
 * 1. 抽壳的输入真相是模型拓扑（移除面），因此必须收口到 `model-topology` binding；
 * 2. 与圆角/倒角不同，抽壳只有面引用，没有边、顶点或帮助点；
 * 3. 上层命令适配器与编辑桥统一复用本函数，避免重复拼 `referenceBindings`。
 */

import { ModelTopologyFeatureBinding } from './ModelTopologyFeatureBinding';

/**
 * 构建抽壳模型拓扑绑定。
 *
 * @param input 构建输入。
 * @returns 可写入命令参数的绑定列表。
 */
export function buildShellModelTopologyBindings(input: {
    upstreamBodyObjectId?: string | null;
    definition: ShellFeatureDefinition;
}): SerializedFeatureReferenceBinding[] {
    // 整体内部掏空没有移除面，但必须声明对上游实体的引用，否则依赖图/删除计划器无法追踪。
    if (input.definition.hollowWholeBody === true) {
        const bodyObjectId = input.upstreamBodyObjectId ?? null;
        if (!bodyObjectId) {
            return [];
        }
        return [
            ModelTopologyFeatureBinding.createPayload({
                bodyObjectId,
                items: [],
            }),
        ];
    }

    const items = Array.isArray(input.definition.removedFaces)
        ? input.definition.removedFaces
        : [];
    const bodyObjectId = input.upstreamBodyObjectId
        ?? items[0]?.bodyObjectId
        ?? null;
    if (!bodyObjectId) {
        return [];
    }
    if (items.length <= 0) {
        return [];
    }
    return [
        ModelTopologyFeatureBinding.createPayload({
            bodyObjectId,
            items,
        }),
    ];
}
